import React from 'react'
import ReactStars from "react-rating-stars-component"
import { Link } from 'react-router-dom'
import labtopRog from '../../../assets/images/product/banner/labtopROG4.jpg'
import s from '../../../assets/images/product/banner/ddr4.jfif'
import ss from '../../../assets/images/product/banner/vga.png'
import sss from '../../../assets/images/product/banner/powerSupply.jpg'
import "./Discounted_products.css"

function Discounted_products() {
  const daprota = [
    {
      '_id': '1',
      'name': ' لپتاپ ایسوس  ',
      'images': labtopRog,
      'fullName': ' کارت گرافیک ایسوس مدل  Dual GEFORCE GTX 1070 8GB',
      'price': 8200000,
    },
    {
      '_id': '2',
      'name': ' رم کامپیوتر ',
      'images': s,
      'fullName': ' کارت گرافیک ایسوس مدل  Dual GEFORCE GTX 1070 8GB',
      'price': 8200000,
    }, {
      '_id': '3',
      'name': 'کارت گرافیک ',
      'images': ss,
      'fullName': ' کارت گرافیک ایسوس مدل  Dual GEFORCE GTX 1070 8GB',
      'price': 8200000,
    }, {
      '_id': '4',
      'name': ' فن خنک کننده ',
      'images': sss,
      'fullName': ' کارت گرافیک ایسوس مدل  Dual GEFORCE GTX 1070 8GB',
      'price': 8200000,
    },
  ]
  return (
    <div className="row">
      {
        daprota.map(product => (
          <div className='col-12 col-sm-6 my-3 'key={product._id} >
            <div className="discounted-products-card">
              <div className="d-flex flex-wrap justify-content-between p-2 p-lg-0">
                <div className='col-12 col-lg-6'>
                  <img src={product.images} className='img-fluid rounded-3' alt="" />
                </div>
                <div className="col-12 col-lg-5 pt-3 pt-lg-0 ">
                  <h5 className="brand">{product.name}</h5>
                  {/* <h6 className="title">{product.fullName} </h6> */}
                  <ReactStars
                    count={5}
                    size={24}
                    value={3}
                    activeColor="#ffd700" />
                  <p><strike> 500ت  </strike> <span className="red-p ps-2"> 200ت </span></p>
                  <div className="discount-till d-flex flex-wrap align-items-center gap-10">
                    <p className='mb-0'>
                      <b>5 </b>روز
                    </p>
                    <div className="d-flex gap-10 align-items-center">
                      <span className="badge rounded-circle p-3 bg-danger">1</span> :
                      <span className="badge rounded-circle p-3 bg-danger">1</span> :
                      <span className="badge rounded-circle p-3 bg-danger">1</span>
                    </div>
                    <div className="row col-12 align-items-center">
                      <div className="my-3 col-10">
                        <p>محصولات : 5 </p>
                        <div className="progress" role="progressbar" aria-label="Basic example" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                          <div className="progress-bar" style={{ width: "25%" }} ></div>
                        </div>
                      </div>
                      <Link className='btn col-2 align-items-center'><span className="bi bi-cart-fill h4 text-warning pt-3"></span></Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
    </div>
  )
}

export default Discounted_products